import React, { useCallback, useEffect, useState } from 'react'
import { useCMSContext } from './CMSContext'
import Content from './Content/Content'
import MenuSection from './MenuSection/MenuSection'
import {
  CMShook,
  CMShookIarMember,
  CMSHookDepartmentTimeBalance,
  CMSHookAppConfiguration
} from './CMShook'
import TopBar from './Header/topbar'
import './CMS.scss'
import { io } from 'socket.io-client'
import { TiChevronRight } from 'react-icons/ti'
import Interceptor from '../../Services/serviceBase.interceptor'
import { useMenuSectionContext } from '../CMS/MenuSection/MenuSectionContext'
import { useErrorSnackBarContext } from '../Shared/ErrorSnackBar/ErrorSnackBarContext'
import MenuSectionActions from './MenuSection/MenuSectionActions'

function CMS({ isRunning }) {
  Interceptor.interceptor(useErrorSnackBarContext().errorSnackBarActions)
  const menuSectionContext = useMenuSectionContext()
  const {
    setDisabledSort,
    setDisableWelcomeOption,
    setDisableRecruitmentOption,
    setDisableGalleryOption,
    setDisableDonateOption,
    setCustomSectionSaving,
    setNewSectionSaving,
    setCustomSections,
    setMenuMarketingSections
  } = menuSectionContext.actions
  const { recruitmentName, customSectionsSaving, newSectionSaving, galleryName, donateName } =
    menuSectionContext.state
  const { errorSnackBarActions } = useErrorSnackBarContext()
  const { state, actions } = useCMSContext()
  const {
    section,
    socket,
    fireDepartment,
    newsDisable,
    iarMember,
    disableCMSOptionsFull,
    isReadOnlyMember
  } = state
  const { setSection, setSocket, setNewsDisable, setDepartmentTimeBalance } = actions

  CMShookIarMember()
  CMShook()
  CMSHookDepartmentTimeBalance()
  CMSHookAppConfiguration()

  //This is for menu section not CMS @salomon
  const [rtl] = useState(false)
  const [collapsed] = useState(false)
  const [image] = useState(true)
  const [toggled, setToggled] = useState(false)
  const [errorLabel] = useState('')
  const [showDeleteCustom, setShowDeleteCustom] = useState(false)

  const handleToggleSidebar = useCallback(
    (value) => {
      setToggled(value)
      setShowDeleteCustom(false)
    },
    [setToggled, setShowDeleteCustom]
  )

  useEffect(() => {
    if (errorLabel !== '') {
      errorSnackBarActions.setOpen(true, errorLabel)
    }
  }, [errorLabel, errorSnackBarActions])

  useEffect(() => {
    if (fireDepartment) {
      let url_socket = `${window._env_.COMMUNITY_SOCKET_URL}`
      console.log(
        `SOCKET ${window._env_.COMMUNITY_SOCKET_URL}, with department ${fireDepartment.fireDepartmentId}`
      )
      // if (!socket){
      setSocket(
        io(url_socket, {
          transports: ['websocket'],
          withCredentials: true,
          query: { id: fireDepartment.fireDepartmentId }
        })
      )
      console.log(
        `Connection success SOCKET ${window._env_.COMMUNITY_SOCKET_URL}, with department ${fireDepartment.fireDepartmentId}`
      )
      // }
    }
  }, [fireDepartment]) //Do not add setSocket nor Socket to the array filter in order to ensure the flow for just one time.

  const addCustomId = useCallback(
    (id) => {
      setCustomSectionSaving([...customSectionsSaving, id])
    },
    [customSectionsSaving, setCustomSectionSaving]
  )

  const deleteCustomId = useCallback(
    (id) => {
      let array = [...customSectionsSaving]
      let filterSections = array.filter((el) => el !== id)
      setCustomSectionSaving(filterSections)
    },
    [customSectionsSaving, setCustomSectionSaving]
  )

  const deleteLastSectionInSaving = useCallback(() => {
    let array = [...newSectionSaving]
    array.splice(-1, 1)
    setCustomSectionSaving(array)
  }, [newSectionSaving, setNewSectionSaving])

  useEffect(() => {
    //if member is admin
    setDisabledSort(isReadOnlyMember || customSectionsSaving.length > 0)
  }, [isReadOnlyMember, setDisabledSort, customSectionsSaving])

  useEffect(() => {
    if (fireDepartment && socket) {
      socket.on(fireDepartment.fireDepartmentId.toString(), (args) => {
        console.log('Firedepartment channel', args, new Date())
        if (args.param && Array.isArray(args.param)) {
          if (
            args.param.includes(`${fireDepartment.fireDepartmentId.toString()}_recruitment`) &&
            args.param.includes(`${fireDepartment.fireDepartmentId.toString()}_inner_recruitment`)
          ) {
            setDisableRecruitmentOption(true)
          }
          if (
            args.param.includes(`${fireDepartment.fireDepartmentId.toString()}_welcome_message`) &&
            args.param.includes(
              `${fireDepartment.fireDepartmentId.toString()}_inner_welcome_message`
            )
          ) {
            setDisableWelcomeOption(true)
          }
          if (
            args.param.includes(`${fireDepartment.fireDepartmentId.toString()}_donate`) &&
            args.param.includes(`${fireDepartment.fireDepartmentId.toString()}_inner_donate`)
          ) {
            setDisableDonateOption(true)
          }
          if (
            args.param.includes(`${fireDepartment.fireDepartmentId.toString()}_gallery`) &&
            args.param.includes(`${fireDepartment.fireDepartmentId.toString()}_inner_gallery`)
          ) {
            setDisableGalleryOption(true)
          }
        }
        const blocked_not_null =
          args.cs_blocked?.filter((x) => {
            return x != null
          }) ?? []
        if (blocked_not_null.length > 0) {
          setDisabledSort(true)
          args.cs_blocked.forEach((el) => {
            if (el) addCustomId(el)
          })
        }
      })

      socket.on(`${fireDepartment.fireDepartmentId.toString()}_welcome_message`, (args) => {
        console.log('Firedepartment Welcome Message channel', args, new Date())
        if (args.action === 'start') {
          setDisableWelcomeOption(true)
        }
        if (args.action === 'error') {
          setDisableWelcomeOption(false)
        }
        if (args.action === 'saved') {
          setDisableWelcomeOption(false)
          if (iarMember && args.memberId === iarMember.memberId) {
            errorSnackBarActions.setOpen(true, 'Home saved', 'success', 7000)
          }
        }
      })

      const customSectionSocket = async (args) => {
        console.log(
          `${fireDepartment.fireDepartmentId.toString()}_custom_section`,
          args,
          new Date()
        )
        if (args.action === 'start' && !customSectionsSaving.includes(args.customSectionId)) {
          setDisabledSort(true)
          if (args.customSectionId) addCustomId(args.customSectionId)
        }
        if (args.action === 'error' && customSectionsSaving.includes(args.customSectionId)) {
          if (args.customSectionId) deleteCustomId(args.customSectionId)
          setDisabledSort(false)
        }
        if (args.action === 'saved') {
          if (!args.updated) {
            deleteLastSectionInSaving()
          } else if (args.customSectionId && customSectionsSaving.includes(args.customSectionId)) {
            deleteCustomId(args.customSectionId)
          }
          if (iarMember && args.memberId === iarMember.memberId) {
            errorSnackBarActions.setOpen(true, 'Section saved', 'success', 7000)
          }
          const response = await MenuSectionActions.getCustomSections(fireDepartment.identifier)
          setCustomSections(response)
        }
      }

      socket.on(`${fireDepartment.fireDepartmentId.toString()}_custom_section`, (args) => {
        customSectionSocket(args)
      })

      socket.on(`${fireDepartment.fireDepartmentId.toString()}_recruitment`, (args) => {
        console.log('Firedepartment Recruitment channel', args, new Date())
        if (args.action === 'start') {
          setDisableRecruitmentOption(true)
        }
        if (args.action === 'error') {
          setDisableRecruitmentOption(false)
        }
        if (args.action === 'saved') {
          setDisableRecruitmentOption(false)
          if (iarMember && args.memberId === iarMember.memberId) {
            let message = `${recruitmentName} saved`
            errorSnackBarActions.setOpen(true, message, 'success', 7000)
          }
        }
      })

      socket.on(`${fireDepartment.fireDepartmentId.toString()}_gallery`, (args) => {
        console.log('Firedepartment Gallery channel', args, new Date())
        if (args.action === 'start') {
          setDisableGalleryOption(true)
        }
        if (args.action === 'error' || args.action === 'nocontent') {
          setDisableGalleryOption(false)
        }
        if (args.action === 'saved' || args.action === 'nocontent') {
          setDisableGalleryOption(false)
          if (iarMember && args.memberId === iarMember.memberId) {
            let message = `${galleryName} saved`
            errorSnackBarActions.setOpen(true, message, 'success', 7000)
          }
        }
      })

      socket.on(`${fireDepartment.fireDepartmentId.toString()}_donate`, (args) => {
        console.log('Firedepartment Donate channel', args, new Date())

        if (args.action === 'start') {
          setDisableDonateOption(true)
        }
        if (args.action === 'saved') {
          setDisableDonateOption(false)
          if (iarMember && args.memberId === iarMember.memberId) {
            let message = `${donateName} saved`
            errorSnackBarActions.setOpen(true, message, 'success', 7000)
          }
        }

        if (args.action === 'error') setDisableDonateOption(false)
      })

      socket.on(`${fireDepartment.fireDepartmentId.toString()}_cms_news`, (args) => {
        console.log(`${fireDepartment.fireDepartmentId.toString()}_cms_news`, args, new Date())
        if (args.param === 'saved') {
          if (iarMember && args.memberId === iarMember.memberId) {
            errorSnackBarActions.setOpen(true, 'News saved', 'success', 7000)
          }
        }
      })

      socket.on(
        `${fireDepartment.fireDepartmentId.toString()}_department_time_balance_update`,
        (args) => {
          console.log(
            `${fireDepartment.fireDepartmentId.toString()}_department_time_balance_update`
          )
          if (args.param === 'update' && args.departmentTimeBalance) {
            setDepartmentTimeBalance(args.departmentTimeBalance.data)
          }
        }
      )

      socket.on(`marketing_section_cms_marketing`, async (args) => {
        console.log(`marketing_section_cms_marketing`, args, new Date())
        if (args.param === 'saved') {
          if (iarMember && args.memberId === iarMember.memberId && isReadOnlyMember) {
            errorSnackBarActions.setOpen(true, 'Marketing section saved', 'success', 7000)
          }
        }
        const response = await MenuSectionActions.getMarketingSectionsByDepartment(fireDepartment)
        setMenuMarketingSections(response)
      })
      
    }
    return () => {
      if (socket) {
        socket.off(fireDepartment.fireDepartmentId.toString())
        socket.off(`${fireDepartment.fireDepartmentId.toString()}_welcome_message`)
        socket.off(`${fireDepartment.fireDepartmentId.toString()}_custom_section`)
        socket.off(`${fireDepartment.fireDepartmentId.toString()}_recruitment`)
        socket.off(`${fireDepartment.fireDepartmentId.toString()}_gallery`)
        socket.off(`${fireDepartment.fireDepartmentId.toString()}_donate`)
        socket.off(`${fireDepartment.fireDepartmentId.toString()}_cms_news`)
        socket.off(`${fireDepartment.fireDepartmentId.toString()}_department_time_balance_update`)
        socket.off(`marketing_section_cms_marketing`)
      }
    }
  }, [
    socket,
    fireDepartment,
    recruitmentName,
    iarMember,
    setDisableWelcomeOption,
    errorSnackBarActions,
    setDisableRecruitmentOption,
    setDisableGalleryOption,
    setDisableDonateOption,
    setNewsDisable,
    newsDisable,
    setDisabledSort,
    addCustomId,
    deleteCustomId,
    customSectionsSaving,
    deleteLastSectionInSaving,
    setDepartmentTimeBalance,
    galleryName,
    donateName,
    isReadOnlyMember,
    setCustomSections
  ])

  //This is for menu section not CMS @salomon
  return (
    <>
      <div>
        <TopBar> this is the header</TopBar>
      </div>
      <div className={`cms app ${rtl ? 'rtl' : ''} ${toggled ? 'toggled' : ''}`}>
        <MenuSection
          image={image}
          collapsed={collapsed}
          rtl={rtl}
          toggled={toggled}
          handleToggleSidebar={handleToggleSidebar}
          setSection={setSection}
          showDeleteCustom={showDeleteCustom}
          setShowDeleteCustom={setShowDeleteCustom}
        />
        {!toggled && (
          <div className="btn-toggle-arrow" onClick={() => handleToggleSidebar(true)}>
            <TiChevronRight size={14} />
          </div>
        )}
        {disableCMSOptionsFull ? <Content section={section} /> : null}
      </div>
    </>
  )
}

//ADd them on welcomemessage
// CMS.propTypes = {
//   isRunning: PropTypes.bool
// }

// CMS.defaultProps = {
//   isRunning: true
// }

export default React.memo(CMS)
